import * as moment from 'moment';

export function isTimeRange(o: any): boolean { return !!o._isTimeRange; }

type TimeDatum = moment.Moment | string | number;

export interface TimeRangeProps {
    from?: TimeDatum; // timestamp in millis or alias
    to?: TimeDatum;
}

export default class TimeRange implements TimeRangeProps {
    public _isTimeRange: boolean;
    startTime?: TimeDatum; // timestamp in millis or alias
    endTime?: TimeDatum;
    from?: TimeDatum; // timestamp in millis or alias
    to?: TimeDatum;

    /*  Converts a flexible singular time type into a numeric unix timestamp or string alias
     */
    private static UnixOrAlias(dt: TimeDatum | undefined) {
        if ( dt === undefined)
            return undefined;
        else if (moment.isMoment(dt))
            return dt.unix();
        else if (!isNaN(dt as number))
            return Number(dt);
        else if (typeof dt === 'string')
            return dt;  // string
        else
            return undefined;
    }

    constructor(props: TimeRangeProps) {
        this._isTimeRange = true;

        this.startTime = moment(props.from).startOf('minute').unix();
        this.endTime = moment(props.to).startOf('minute').unix();

        if (props) {
            this.from = this.startTime || undefined;
            this.to = this.endTime || undefined;
        }
    }

    public toString() {
        let from = TimeRange.UnixOrAlias(this.from),
            to = TimeRange.UnixOrAlias(this.to);

        if (from && to === undefined) {
            return from + ' to current';
        } else if (to && from === undefined) {
            return 'before ' + to;
        } else if (from && to) {
            return from + ' to ' + to;
        }  else {
            return undefined;
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/api/timerange.tsx